// M01 數系與近似值 - 練習題數據 (主題 11-15)
// 系統化設計，準備後續 Supabase 數據遷移
// 每個主題 10 題，共 50 題

// ========== 11. 十進制轉二進制 (10題) ==========
export const M01_11_PROBLEMS = [
  {
    id: 'M01_11_P001',
    topicId: 'M01_11',
    question: "將十進制數 13 轉換為二進制",
    solution: "1101₂",
    explanation: "13 ÷ 2 = 6 餘 1，6 ÷ 2 = 3 餘 0，3 ÷ 2 = 1 餘 1，1 ÷ 2 = 0 餘 1，由下往上讀：1101",
    hint: "重複除以2，記錄餘數",
    difficulty: 2,
    order: 1,
    steps: ["13 ÷ 2 = 6 餘 1", "6 ÷ 2 = 3 餘 0", "3 ÷ 2 = 1 餘 1", "1 ÷ 2 = 0 餘 1", "答案：1101₂"]
  },
  {
    id: 'M01_11_P002',
    topicId: 'M01_11',
    question: "將十進制數 25 轉換為二進制",
    solution: "11001₂",
    explanation: "25 ÷ 2 = 12 餘 1，12 ÷ 2 = 6 餘 0，6 ÷ 2 = 3 餘 0，3 ÷ 2 = 1 餘 1，1 ÷ 2 = 0 餘 1",
    hint: "從下往上讀餘數",
    difficulty: 2,
    order: 2,
    steps: ["25 ÷ 2 = 12 餘 1", "12 ÷ 2 = 6 餘 0", "6 ÷ 2 = 3 餘 0", "3 ÷ 2 = 1 餘 1", "1 ÷ 2 = 0 餘 1", "答案：11001₂"]
  },
  {
    id: 'M01_11_P003',
    topicId: 'M01_11',
    question: "將十進制數 7 轉換為二進制",
    solution: "111₂",
    explanation: "7 ÷ 2 = 3 餘 1，3 ÷ 2 = 1 餘 1，1 ÷ 2 = 0 餘 1",
    hint: "小數字的轉換",
    difficulty: 1,
    order: 3,
    steps: ["7 ÷ 2 = 3 餘 1", "3 ÷ 2 = 1 餘 1", "1 ÷ 2 = 0 餘 1", "答案：111₂"]
  },
  {
    id: 'M01_11_P004',
    topicId: 'M01_11',
    question: "將十進制數 64 轉換為二進制",
    solution: "1000000₂",
    explanation: "64 = 2⁶，所以是 1 後面跟 6 個 0",
    hint: "2的冪次方的特殊情況",
    difficulty: 1,
    order: 4,
    steps: ["64 = 2⁶", "2的冪次方 = 1 後面跟 n 個 0", "答案：1000000₂"]
  },
  {
    id: 'M01_11_P005',
    topicId: 'M01_11',
    question: "將十進制數 100 轉換為二進制",
    solution: "1100100₂",
    explanation: "100 ÷ 2 = 50 餘 0，50 ÷ 2 = 25 餘 0，25 ÷ 2 = 12 餘 1，12 ÷ 2 = 6 餘 0，6 ÷ 2 = 3 餘 0，3 ÷ 2 = 1 餘 1，1 ÷ 2 = 0 餘 1",
    hint: "較大數字的轉換",
    difficulty: 3,
    order: 5,
    steps: ["100 ÷ 2 = 50 餘 0", "50 ÷ 2 = 25 餘 0", "25 ÷ 2 = 12 餘 1", "12 ÷ 2 = 6 餘 0", "6 ÷ 2 = 3 餘 0", "3 ÷ 2 = 1 餘 1", "1 ÷ 2 = 0 餘 1", "答案：1100100₂"]
  },
  {
    id: 'M01_11_P006',
    topicId: 'M01_11',
    question: "將十進制數 15 轉換為二進制",
    solution: "1111₂",
    explanation: "15 ÷ 2 = 7 餘 1，7 ÷ 2 = 3 餘 1，3 ÷ 2 = 1 餘 1，1 ÷ 2 = 0 餘 1",
    hint: "全部都是1的情況",
    difficulty: 2,
    order: 6,
    steps: ["15 ÷ 2 = 7 餘 1", "7 ÷ 2 = 3 餘 1", "3 ÷ 2 = 1 餘 1", "1 ÷ 2 = 0 餘 1", "答案：1111₂"]
  },
  {
    id: 'M01_11_P007',
    topicId: 'M01_11',
    question: "將十進制數 31 轉換為二進制",
    solution: "11111₂",
    explanation: "31 = 2⁵ - 1，所以是 5 個 1",
    hint: "2ⁿ - 1 的特殊情況",
    difficulty: 2,
    order: 7,
    steps: ["31 = 32 - 1 = 2⁵ - 1", "2ⁿ - 1 = n 個 1", "答案：11111₂"]
  },
  {
    id: 'M01_11_P008',
    topicId: 'M01_11',
    question: "將十進制數 42 轉換為二進制",
    solution: "101010₂",
    explanation: "42 ÷ 2 = 21 餘 0，21 ÷ 2 = 10 餘 1，10 ÷ 2 = 5 餘 0，5 ÷ 2 = 2 餘 1，2 ÷ 2 = 1 餘 0，1 ÷ 2 = 0 餘 1",
    hint: "交替的0和1模式",
    difficulty: 2,
    order: 8,
    steps: ["42 ÷ 2 = 21 餘 0", "21 ÷ 2 = 10 餘 1", "10 ÷ 2 = 5 餘 0", "5 ÷ 2 = 2 餘 1", "2 ÷ 2 = 1 餘 0", "1 ÷ 2 = 0 餘 1", "答案：101010₂"]
  },
  {
    id: 'M01_11_P009',
    topicId: 'M01_11',
    question: "將十進制數 255 轉換為二進制",
    solution: "11111111₂",
    explanation: "255 = 2⁸ - 1，所以是 8 個 1",
    hint: "一個字節的最大值",
    difficulty: 2,
    order: 9,
    steps: ["255 = 256 - 1 = 2⁸ - 1", "2ⁿ - 1 = n 個 1", "答案：11111111₂"]
  },
  {
    id: 'M01_11_P010',
    topicId: 'M01_11',
    question: "將十進制數 128 轉換為二進制",
    solution: "10000000₂",
    explanation: "128 = 2⁷，所以是 1 後面跟 7 個 0",
    hint: "2的7次方",
    difficulty: 1,
    order: 10,
    steps: ["128 = 2⁷", "2的冪次方 = 1 後面跟 n 個 0", "答案：10000000₂"]
  }
];

// ========== 12. 二進制轉十進制 (10題) ==========
export const M01_12_PROBLEMS = [
  {
    id: 'M01_12_P001',
    topicId: 'M01_12',
    question: "將二進制數 1101₂ 轉換為十進制",
    solution: "13",
    explanation: "1101₂ = 1×2³ + 1×2² + 0×2¹ + 1×2⁰ = 8 + 4 + 0 + 1 = 13",
    hint: "每一位乘以對應的2的冪次",
    difficulty: 2,
    order: 1,
    steps: ["1×2³ = 1×8 = 8", "1×2² = 1×4 = 4", "0×2¹ = 0×2 = 0", "1×2⁰ = 1×1 = 1", "總和：8 + 4 + 0 + 1 = 13"]
  },
  {
    id: 'M01_12_P002',
    topicId: 'M01_12',
    question: "將二進制數 1010₂ 轉換為十進制",
    solution: "10",
    explanation: "1010₂ = 1×2³ + 0×2² + 1×2¹ + 0×2⁰ = 8 + 0 + 2 + 0 = 10",
    hint: "注意0的位置不貢獻數值",
    difficulty: 2,
    order: 2,
    steps: ["1×2³ = 1×8 = 8", "0×2² = 0×4 = 0", "1×2¹ = 1×2 = 2", "0×2⁰ = 0×1 = 0", "總和：8 + 0 + 2 + 0 = 10"]
  },
  {
    id: 'M01_12_P003',
    topicId: 'M01_12',
    question: "將二進制數 111₂ 轉換為十進制",
    solution: "7",
    explanation: "111₂ = 1×2² + 1×2¹ + 1×2⁰ = 4 + 2 + 1 = 7",
    hint: "三位都是1",
    difficulty: 1,
    order: 3,
    steps: ["1×2² = 1×4 = 4", "1×2¹ = 1×2 = 2", "1×2⁰ = 1×1 = 1", "總和：4 + 2 + 1 = 7"]
  },
  {
    id: 'M01_12_P004',
    topicId: 'M01_12',
    question: "將二進制數 10000₂ 轉換為十進制",
    solution: "16",
    explanation: "10000₂ = 1×2⁴ + 0×2³ + 0×2² + 0×2¹ + 0×2⁰ = 16",
    hint: "只有最高位是1",
    difficulty: 1,
    order: 4,
    steps: ["1×2⁴ = 1×16 = 16", "其他位都是0", "總和：16"]
  },
  {
    id: 'M01_12_P005',
    topicId: 'M01_12',
    question: "將二進制數 11001₂ 轉換為十進制",
    solution: "25",
    explanation: "11001₂ = 1×2⁴ + 1×2³ + 0×2² + 0×2¹ + 1×2⁰ = 16 + 8 + 0 + 0 + 1 = 25",
    hint: "計算每一位的貢獻",
    difficulty: 2,
    order: 5,
    steps: ["1×2⁴ = 1×16 = 16", "1×2³ = 1×8 = 8", "0×2² = 0", "0×2¹ = 0", "1×2⁰ = 1", "總和：16 + 8 + 0 + 0 + 1 = 25"]
  },
  {
    id: 'M01_12_P006',
    topicId: 'M01_12',
    question: "將二進制數 1111₂ 轉換為十進制",
    solution: "15",
    explanation: "1111₂ = 1×2³ + 1×2² + 1×2¹ + 1×2⁰ = 8 + 4 + 2 + 1 = 15",
    hint: "四個1的和",
    difficulty: 1,
    order: 6,
    steps: ["1×2³ = 8", "1×2² = 4", "1×2¹ = 2", "1×2⁰ = 1", "總和：8 + 4 + 2 + 1 = 15"]
  },
  {
    id: 'M01_12_P007',
    topicId: 'M01_12',
    question: "將二進制數 101010₂ 轉換為十進制",
    solution: "42",
    explanation: "101010₂ = 1×2⁵ + 0×2⁴ + 1×2³ + 0×2² + 1×2¹ + 0×2⁰ = 32 + 0 + 8 + 0 + 2 + 0 = 42",
    hint: "交替的1和0模式",
    difficulty: 3,
    order: 7,
    steps: ["1×2⁵ = 32", "0×2⁴ = 0", "1×2³ = 8", "0×2² = 0", "1×2¹ = 2", "0×2⁰ = 0", "總和：32 + 8 + 2 = 42"]
  },
  {
    id: 'M01_12_P008',
    topicId: 'M01_12',
    question: "將二進制數 1100100₂ 轉換為十進制",
    solution: "100",
    explanation: "1100100₂ = 1×2⁶ + 1×2⁵ + 0×2⁴ + 0×2³ + 1×2² + 0×2¹ + 0×2⁰ = 64 + 32 + 0 + 0 + 4 + 0 + 0 = 100",
    hint: "較長的二進制數",
    difficulty: 3,
    order: 8,
    steps: ["1×2⁶ = 64", "1×2⁵ = 32", "0×2⁴ = 0", "0×2³ = 0", "1×2² = 4", "0×2¹ = 0", "0×2⁰ = 0", "總和：64 + 32 + 4 = 100"]
  },
  {
    id: 'M01_12_P009',
    topicId: 'M01_12',
    question: "將二進制數 11111111₂ 轉換為十進制",
    solution: "255",
    explanation: "11111111₂ = 2⁸ - 1 = 256 - 1 = 255",
    hint: "8個1的特殊情況",
    difficulty: 2,
    order: 9,
    steps: ["8個1 = 2⁸ - 1", "2⁸ = 256", "256 - 1 = 255"]
  },
  {
    id: 'M01_12_P010',
    topicId: 'M01_12',
    question: "將二進制數 10101010₂ 轉換為十進制",
    solution: "170",
    explanation: "10101010₂ = 1×2⁷ + 0×2⁶ + 1×2⁵ + 0×2⁴ + 1×2³ + 0×2² + 1×2¹ + 0×2⁰ = 128 + 32 + 8 + 2 = 170",
    hint: "交替模式的8位數",
    difficulty: 3,
    order: 10,
    steps: ["1×2⁷ = 128", "0×2⁶ = 0", "1×2⁵ = 32", "0×2⁴ = 0", "1×2³ = 8", "0×2² = 0", "1×2¹ = 2", "0×2⁰ = 0", "總和：128 + 32 + 8 + 2 = 170"]
  }
];

// ========== 13. 二進制加法 (10題) ==========
export const M01_13_PROBLEMS = [
  {
    id: 'M01_13_P001',
    topicId: 'M01_13',
    question: "計算二進制加法：101₂ + 11₂",
    solution: "1000₂",
    explanation: "對齊右邊：101₂ + 011₂，從右往左加：1+1=10₂(進位)，0+1+1(進位)=10₂，1+0+1(進位)=10₂，結果：1000₂",
    hint: "記住：1+1=10₂(進位1)",
    difficulty: 2,
    order: 1,
    steps: ["  101₂", "+ 011₂", "------", " 1000₂", "驗證：5 + 3 = 8"]
  },
  {
    id: 'M01_13_P002',
    topicId: 'M01_13',
    question: "計算二進制加法：110₂ + 101₂",
    solution: "1011₂",
    explanation: "從右往左：0+1=1，1+0=1，1+1=10₂(進位)，結果：1011₂",
    hint: "小心處理進位",
    difficulty: 2,
    order: 2,
    steps: ["  110₂", "+ 101₂", "------", " 1011₂", "驗證：6 + 5 = 11"]
  },
  {
    id: 'M01_13_P003',
    topicId: 'M01_13',
    question: "計算二進制加法：1₂ + 1₂",
    solution: "10₂",
    explanation: "1 + 1 = 10₂，這是二進制中的基本進位",
    hint: "最基本的進位情況",
    difficulty: 1,
    order: 3,
    steps: ["  1₂", "+ 1₂", "----", " 10₂", "驗證：1 + 1 = 2"]
  },
  {
    id: 'M01_13_P004',
    topicId: 'M01_13',
    question: "計算二進制加法：1111₂ + 1₂",
    solution: "10000₂",
    explanation: "從右往左：1+1=10₂(進位)，1+0+1(進位)=10₂，連續進位到最高位",
    hint: "連續進位的情況",
    difficulty: 3,
    order: 4,
    steps: ["  1111₂", "+    1₂", "-------", " 10000₂", "驗證：15 + 1 = 16"]
  },
  {
    id: 'M01_13_P005',
    topicId: 'M01_13',
    question: "計算二進制加法：1010₂ + 0101₂",
    solution: "1111₂",
    explanation: "從右往左：0+1=1，1+0=1，0+1=1，1+0=1，結果：1111₂",
    hint: "沒有進位的情況",
    difficulty: 2,
    order: 5,
    steps: ["  1010₂", "+ 0101₂", "-------", "  1111₂", "驗證：10 + 5 = 15"]
  },
  {
    id: 'M01_13_P006',
    topicId: 'M01_13',
    question: "計算二進制加法：1100₂ + 0011₂",
    solution: "1111₂",
    explanation: "從右往左：0+1=1，0+1=1，1+0=1，1+0=1，結果：1111₂",
    hint: "互補的數相加",
    difficulty: 2,
    order: 6,
    steps: ["  1100₂", "+ 0011₂", "-------", "  1111₂", "驗證：12 + 3 = 15"]
  },
  {
    id: 'M01_13_P007',
    topicId: 'M01_13',
    question: "計算二進制加法：111₂ + 111₂",
    solution: "1110₂",
    explanation: "從右往左：1+1=10₂(進位)，1+1+1(進位)=11₂(進位)，1+1+1(進位)=11₂，結果：1110₂",
    hint: "相同數字相加",
    difficulty: 3,
    order: 7,
    steps: ["  111₂", "+ 111₂", "------", " 1110₂", "驗證：7 + 7 = 14"]
  },
  {
    id: 'M01_13_P008',
    topicId: 'M01_13',
    question: "計算二進制加法：10110₂ + 1101₂",
    solution: "100011₂",
    explanation: "對齊：10110₂ + 01101₂，從右往左計算每位和進位",
    hint: "不同長度的數相加",
    difficulty: 3,
    order: 8,
    steps: ["  10110₂", "+ 01101₂", "--------", " 100011₂", "驗證：22 + 13 = 35"]
  },
  {
    id: 'M01_13_P009',
    topicId: 'M01_13',
    question: "計算二進制加法：1001₂ + 110₂",
    solution: "1111₂",
    explanation: "對齊：1001₂ + 0110₂，從右往左：1+0=1，0+1=1，0+1=1，1+0=1",
    hint: "對齊數字很重要",
    difficulty: 2,
    order: 9,
    steps: ["  1001₂", "+ 0110₂", "-------", "  1111₂", "驗證：9 + 6 = 15"]
  },
  {
    id: 'M01_13_P010',
    topicId: 'M01_13',
    question: "計算二進制加法：11011₂ + 10111₂",
    solution: "110010₂",
    explanation: "從右往左計算，注意多次進位：1+1=10₂，1+1+1(進位)=11₂，等等",
    hint: "複雜的多位進位",
    difficulty: 3,
    order: 10,
    steps: ["  11011₂", "+ 10111₂", "--------", " 110010₂", "驗證：27 + 23 = 50"]
  }
];

// ========== 14. 進制驗證 (10題) ==========
export const M01_14_PROBLEMS = [
  {
    id: 'M01_14_P001',
    topicId: 'M01_14',
    question: "驗證：十進制 13 = 二進制 1101₂ 是否正確？",
    solution: "正確",
    explanation: "1101₂ = 1×8 + 1×4 + 0×2 + 1×1 = 8 + 4 + 0 + 1 = 13 ✓",
    hint: "將二進制轉回十進制驗證",
    difficulty: 1,
    order: 1,
    steps: ["1101₂ = 1×2³ + 1×2² + 0×2¹ + 1×2⁰", "= 8 + 4 + 0 + 1", "= 13 ✓"]
  },
  {
    id: 'M01_14_P002',
    topicId: 'M01_14',
    question: "驗證：十進制 25 = 二進制 11000₂ 是否正確？",
    solution: "錯誤，應該是 11001₂",
    explanation: "11000₂ = 1×16 + 1×8 = 24 ≠ 25，正確答案是 11001₂ = 16 + 8 + 1 = 25",
    hint: "計算二進制的實際值",
    difficulty: 2,
    order: 2,
    steps: ["11000₂ = 1×16 + 1×8 + 0×4 + 0×2 + 0×1", "= 16 + 8 = 24 ≠ 25", "正確答案：11001₂"]
  },
  {
    id: 'M01_14_P003',
    topicId: 'M01_14',
    question: "驗證：101₂ + 11₂ = 1000₂ 是否正確？",
    solution: "正確",
    explanation: "101₂ = 5，11₂ = 3，5 + 3 = 8，1000₂ = 8 ✓",
    hint: "轉換為十進制驗證加法",
    difficulty: 2,
    order: 3,
    steps: ["101₂ = 5", "11₂ = 3", "5 + 3 = 8", "1000₂ = 8 ✓"]
  },
  {
    id: 'M01_14_P004',
    topicId: 'M01_14',
    question: "驗證：十進制 100 = 二進制 1100100₂ 是否正確？",
    solution: "正確",
    explanation: "1100100₂ = 64 + 32 + 4 = 100 ✓",
    hint: "計算各位的貢獻",
    difficulty: 2,
    order: 4,
    steps: ["1100100₂ = 1×64 + 1×32 + 0×16 + 0×8 + 1×4 + 0×2 + 0×1", "= 64 + 32 + 4", "= 100 ✓"]
  },
  {
    id: 'M01_14_P005',
    topicId: 'M01_14',
    question: "驗證：1111₂ + 1₂ = 10000₂ 是否正確？",
    solution: "正確",
    explanation: "1111₂ = 15，1₂ = 1，15 + 1 = 16，10000₂ = 16 ✓",
    hint: "進位到更高位的情況",
    difficulty: 2,
    order: 5,
    steps: ["1111₂ = 15", "1₂ = 1", "15 + 1 = 16", "10000₂ = 16 ✓"]
  },
  {
    id: 'M01_14_P006',
    topicId: 'M01_14',
    question: "驗證：十進制 64 = 二進制 1000000₂ 是否正確？",
    solution: "正確",
    explanation: "1000000₂ = 1×2⁶ = 64 ✓",
    hint: "2的冪次方的驗證",
    difficulty: 1,
    order: 6,
    steps: ["1000000₂ = 1×2⁶", "2⁶ = 64 ✓"]
  },
  {
    id: 'M01_14_P007',
    topicId: 'M01_14',
    question: "驗證：110₂ + 101₂ = 1001₂ 是否正確？",
    solution: "錯誤，應該是 1011₂",
    explanation: "110₂ = 6，101₂ = 5，6 + 5 = 11，1001₂ = 9 ≠ 11，正確答案是 1011₂ = 11",
    hint: "重新計算加法結果",
    difficulty: 2,
    order: 7,
    steps: ["110₂ = 6", "101₂ = 5", "6 + 5 = 11", "1001₂ = 9 ≠ 11", "正確答案：1011₂ = 11"]
  },
  {
    id: 'M01_14_P008',
    topicId: 'M01_14',
    question: "驗證：十進制 255 = 二進制 11111111₂ 是否正確？",
    solution: "正確",
    explanation: "11111111₂ = 2⁸ - 1 = 256 - 1 = 255 ✓",
    hint: "8位全1的特殊情況",
    difficulty: 1,
    order: 8,
    steps: ["11111111₂ = 2⁸ - 1", "2⁸ = 256", "256 - 1 = 255 ✓"]
  },
  {
    id: 'M01_14_P009',
    topicId: 'M01_14',
    question: "驗證：1010₂ + 0101₂ = 1111₂ 是否正確？",
    solution: "正確",
    explanation: "1010₂ = 10，0101₂ = 5，10 + 5 = 15，1111₂ = 15 ✓",
    hint: "互補數的加法",
    difficulty: 2,
    order: 9,
    steps: ["1010₂ = 10", "0101₂ = 5", "10 + 5 = 15", "1111₂ = 15 ✓"]
  },
  {
    id: 'M01_14_P010',
    topicId: 'M01_14',
    question: "驗證：十進制 42 = 二進制 101010₂ 是否正確？",
    solution: "正確",
    explanation: "101010₂ = 32 + 8 + 2 = 42 ✓",
    hint: "交替1和0模式的驗證",
    difficulty: 2,
    order: 10,
    steps: ["101010₂ = 1×32 + 0×16 + 1×8 + 0×4 + 1×2 + 0×1", "= 32 + 8 + 2", "= 42 ✓"]
  }
];

// ========== 15. 基本面積計算 (10題) ==========
export const M01_15_PROBLEMS = [
  {
    id: 'M01_15_P001',
    topicId: 'M01_15',
    question: "長方形長 5.2 m，寬 3.0 m，求面積（注意有效數字）",
    solution: "16 m²",
    explanation: "面積 = 5.2 × 3.0 = 15.6 m²，3.0只有2個有效數字，所以答案是16 m²",
    hint: "乘法運算要注意有效數字",
    difficulty: 2,
    order: 1,
    steps: ["面積 = 長 × 寬", "= 5.2 × 3.0 = 15.6", "3.0有2個有效數字", "答案：16 m²"]
  },
  {
    id: 'M01_15_P002',
    topicId: 'M01_15',
    question: "正方形邊長 4.5 cm，求面積（注意有效數字）",
    solution: "20 cm²",
    explanation: "面積 = (4.5)² = 20.25 cm²，4.5有2個有效數字，答案是20 cm²",
    hint: "平方運算的有效數字",
    difficulty: 2,
    order: 2,
    steps: ["面積 = 邊長²", "= (4.5)² = 20.25", "4.5有2個有效數字", "答案：20 cm²"]
  },
  {
    id: 'M01_15_P003',
    topicId: 'M01_15',
    question: "圓的半徑 2.5 cm，求面積（π ≈ 3.14159，注意有效數字）",
    solution: "20 cm²",
    explanation: "面積 = πr² = 3.14159 × (2.5)² = 19.635 cm²，2.5有2個有效數字，答案是20 cm²",
    hint: "π可以取足夠精度，r決定有效數字",
    difficulty: 2,
    order: 3,
    steps: ["面積 = πr²", "= 3.14159 × (2.5)²", "= 3.14159 × 6.25 = 19.635", "2.5有2個有效數字，答案：20 cm²"]
  },
  {
    id: 'M01_15_P004',
    topicId: 'M01_15',
    question: "三角形底邊 6.0 m，高 4.2 m，求面積（注意有效數字）",
    solution: "13 m²",
    explanation: "面積 = ½ × 底 × 高 = ½ × 6.0 × 4.2 = 12.6 m²，兩數都有2個有效數字，答案是13 m²",
    hint: "三角形面積公式",
    difficulty: 2,
    order: 4,
    steps: ["面積 = ½ × 底 × 高", "= ½ × 6.0 × 4.2", "= 12.6", "兩數都有2個有效數字，答案：13 m²"]
  },
  {
    id: 'M01_15_P005',
    topicId: 'M01_15',
    question: "測量長方形：長 12.34 ± 0.05 m，寬 8.7 ± 0.1 m，求面積和誤差界限",
    solution: "面積：107 ± 2 m²",
    explanation: "面積 = 12.34 × 8.7 = 107.358 m²，相對誤差 ≈ (0.05/12.34) + (0.1/8.7) ≈ 0.016，誤差 ≈ 107 × 0.016 ≈ 2 m²",
    hint: "面積計算的誤差傳播",
    difficulty: 3,
    order: 5,
    steps: ["面積 = 12.34 × 8.7 = 107.358", "相對誤差 ≈ (0.05/12.34) + (0.1/8.7)", "≈ 0.004 + 0.011 = 0.015", "絕對誤差 ≈ 107 × 0.015 ≈ 2", "答案：107 ± 2 m²"]
  },
  {
    id: 'M01_15_P006',
    topicId: 'M01_15',
    question: "圓的直徑測量為 10.0 ± 0.2 cm，求面積和誤差界限",
    solution: "面積：79 ± 3 cm²",
    explanation: "半徑 = 5.0 ± 0.1 cm，面積 = π × (5.0)² = 78.54 cm²，相對誤差 ≈ 2 × (0.1/5.0) = 0.04，誤差 ≈ 79 × 0.04 ≈ 3 cm²",
    hint: "圓面積的誤差分析",
    difficulty: 3,
    order: 6,
    steps: ["半徑 = 5.0 ± 0.1 cm", "面積 = π × (5.0)² = 78.54", "相對誤差 ≈ 2 × (0.1/5.0) = 0.04", "絕對誤差 ≈ 79 × 0.04 ≈ 3", "答案：79 ± 3 cm²"]
  },
  {
    id: 'M01_15_P007',
    topicId: 'M01_15',
    question: "梯形上底 3.5 m，下底 5.2 m，高 2.8 m，求面積（注意有效數字）",
    solution: "12 m²",
    explanation: "面積 = ½ × (上底 + 下底) × 高 = ½ × (3.5 + 5.2) × 2.8 = ½ × 8.7 × 2.8 = 12.18 m²，答案是12 m²",
    hint: "梯形面積公式",
    difficulty: 2,
    order: 7,
    steps: ["面積 = ½ × (上底 + 下底) × 高", "= ½ × (3.5 + 5.2) × 2.8", "= ½ × 8.7 × 2.8 = 12.18", "答案：12 m²"]
  },
  {
    id: 'M01_15_P008',
    topicId: 'M01_15',
    question: "正方形周長測量為 20.0 ± 0.4 cm，求面積和誤差界限",
    solution: "面積：25 ± 1 cm²",
    explanation: "邊長 = 20.0/4 = 5.0 ± 0.1 cm，面積 = (5.0)² = 25 cm²，相對誤差 ≈ 2 × (0.1/5.0) = 0.04，誤差 ≈ 25 × 0.04 = 1 cm²",
    hint: "從周長求邊長再求面積",
    difficulty: 3,
    order: 8,
    steps: ["邊長 = 周長/4 = 5.0 ± 0.1 cm", "面積 = (5.0)² = 25", "相對誤差 ≈ 2 × (0.1/5.0) = 0.04", "絕對誤差 ≈ 1", "答案：25 ± 1 cm²"]
  },
  {
    id: 'M01_15_P009',
    topicId: 'M01_15',
    question: "橢圓長軸 8.0 m，短軸 6.0 m，求面積（注意有效數字）",
    solution: "38 m²",
    explanation: "面積 = π × (a/2) × (b/2) = π × 4.0 × 3.0 = 37.7 m²，兩軸都有2個有效數字，答案是38 m²",
    hint: "橢圓面積 = π × 半長軸 × 半短軸",
    difficulty: 2,
    order: 9,
    steps: ["半長軸 = 4.0 m，半短軸 = 3.0 m", "面積 = π × 4.0 × 3.0", "= 37.7", "答案：38 m²"]
  },
  {
    id: 'M01_15_P010',
    topicId: 'M01_15',
    question: "房間長 4.2 ± 0.1 m，寬 3.8 ± 0.1 m，求地板面積和誤差界限",
    solution: "面積：16.0 ± 0.8 m²",
    explanation: "面積 = 4.2 × 3.8 = 15.96 m²，相對誤差 ≈ (0.1/4.2) + (0.1/3.8) ≈ 0.05，誤差 ≈ 16 × 0.05 ≈ 0.8 m²",
    hint: "實際測量的誤差分析",
    difficulty: 3,
    order: 10,
    steps: ["面積 = 4.2 × 3.8 = 15.96", "相對誤差 ≈ (0.1/4.2) + (0.1/3.8)", "≈ 0.024 + 0.026 = 0.05", "絕對誤差 ≈ 16 × 0.05 = 0.8", "答案：16.0 ± 0.8 m²"]
  }
]; 